// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1azAi","footer":"styles_footer__ndLda"};